<template>
  <div class="page" style="margin:0;background: #F7F7F7;">
    <!-- 顶部 card-->
    <div class="bg_top_linear-gradient  vip_bg">
      <!-- 用户信息 -->
      <div class="user_box flex-r-sb-c">
        <div class="user_info flex-r-sb-c">
          <div class="user_avater">
            <van-image width="1.33rem" round fit="cover" height="1.33rem"
                       src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/my/my_avater_01.png"
            />
            <van-image v-if="isVip" class="vip_avater" width="1.11rem" round fit="cover" height="0.45rem"
                       :src="`https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/vpi_avater${vipIndex*1+1}.png`"
            />
          </div>
          <div class="user_name_kind flex-c-s-s">
            <div class="user_name van-ellipsis" style="text-align: left;">{{ info.name || '分销商城用户' }}</div>
            <div class="user_kind">{{ info.industryName || '分销用户' }}</div>
          </div>
        </div>
        <div class="user_info_change flex-r-c-c" @click="$router.push('/user/myInfo')">
          <van-icon name="setting-o" color="#0a69ac" />
          <span>完善资料</span>
        </div>
      </div>
      <!-- vip -->
      <div :id="'vipbg' + vipIndex" style="display:none"
           :class=" isVip ? 'user_vip_box vip_1-4' :'user_vip_box vip_0' "
      >
        <!-- vip0 -->
        <div v-if="!isVip" class="flex-r-sb-c" style="padding-top: 0.19rem;">
          <div class="vip_box_bg flex-r-s-c">
            <van-image width="0.64rem" height="0.64rem"
                       src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/vip_logo.png"
            />
            <div class="vip_name">商城会员</div>
            <div class="vip_tips">买单折上折 即领即用</div>
          </div>
          <van-image width="1.84rem" height="0.61rem" style="margin-right:0.3rem"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/vip_get.png" @click="getVip"
          />
        </div>
        <!-- vip1-4 -->
        <div v-if="isVip" class="" style="padding-top: 0.19rem;">
          <div class="vip_box_bg flex-r-sb-c">
            <van-image width="5.33rem" height="0.75rem"
                       :src="`https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/vip_my_logo_0${vipIndex*1+1}.png`"
            />
            <div :id="'time_0'+(vipIndex*1+1)" class="vip_box_time">{{ vipInfo.expirationTime }}到期</div>
          </div>
          <div class="vip_box_info flex-r-sb-c">
            <div :id="'time_0'+(vipIndex*1+1)" class="vip_money">
              <div>累计已省</div>
              <div class="flex-r-s-c" style="margin-top: 0.11rem;">
                <div class="vip_num">{{ vipInfo.accumulatedSaved }}</div> 元
              </div>
            </div>
            <!-- <div class="vip_box_detail" @click="toVipDetail">看详情</div> -->
            <div>
              <van-image width="2.4rem" height="0.8rem"
                         :src="`https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/vip_btn_${vipIndex*1+1}.png`"
                         @click="toVipDetail"
              />
            </div>
          </div>
        </div>
        <div :class="isVip ? 'vip_white vip_white_1-4':'vip_white vip_0'" />
      </div>
      <!-- 订单 -->

      <!-- 订单区域 -->
      <div class="user_order_card">
        <div class="order_card_title flex-r-sb-c">
          <div class="order_card_name">我的订单</div>
          <div class="order_card_tips" @click="jumpOrder(0)">全部订单
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="order_card_item flex-r-sa-c">
          <div v-for="(order,order_index) in userOrderCardList" :key="order_index" style="width:20%"
               @click="jumpOrder(order.id)"
          >
            <van-badge v-if="order.id === 2" :content="badge === 0 ? null : badge" class="my-van-badge">
              <van-image width="1.17rem" height="1.17rem" :src="order.img" />
            </van-badge>
            <div v-else class="my-van-badge">
              <van-image width="1.17rem" height="1.17rem" :src="order.img" />
            </div>
            <div class="item_name">{{ order.name }}</div>
          </div>
        </div>
      </div>
      <div class="user_card flex-r-sb-c">
        <div class="card_item card_item01" @click="toJump(6)">
          <div class="card_item_title">我的代理</div>
          <div class="card_item_msg">城市独代续期</div>
          <img src="../../assets/my_agency_icon.png" alt="">
        </div>
        <div class="card_item card_item02" @click="toJump(7)">
          <div class="card_item_title" style="color: #F27100;">我的优惠券</div>
          <div class="card_item_msg" style="color: #F27100;">共{{ userCouponCount }}张</div>
          <img src="../../assets/my_coupon_icon.png" alt="">
        </div>
      </div>
      <div class="my_concent " style="margin-top: 0.2rem;">
        <!-- card -->
        <div class="user_cell">
          <!-- <div class="cell_item flex-r-sb-c" @click="toJump(6)">
            <div class="msg flex-r-s-c">
              <van-image width="1.07rem" fit="cover" height="1.07rem" style="padding-right:0.21rem"
                         :src="require('../../assets/UI2/my_card06.png')"
              />
              <div class=" flex-c-s-s">
                <div class="name">我的代理</div>
                <div class="contant">城市独代续期</div>
              </div>
            </div>
            <van-icon name="arrow" color="rgb(200, 200, 200)" size="0.4rem" />
          </div>
          <van-divider /> -->
          <div class="cell_item flex-r-sb-c" @click="toJump(2)">
            <div class="msg flex-r-s-c">
              <van-image width="1.07rem" fit="cover" height="1.07rem" style="padding-right:0.21rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_card01.png"
              />
              <div class="flex-c-s-s">
                <div class="name">地址管理</div>
                <div class="contant">我的收货地址</div>
              </div>
            </div>
            <van-icon name="arrow" color="rgb(200, 200, 200)" size="0.4rem" />
          </div>
          <van-divider />
          <div class="cell_item flex-r-sb-c" @click="toJump(3)">
            <div class="msg flex-r-s-c">
              <van-image width="1.07rem" fit="cover" height="1.07rem" style="padding-right:0.21rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_card02.png"
              />
              <div class="flex-c-s-s">
                <div class="name">联系客服</div>
                <div class="contant">专业客服解答</div>
              </div>
            </div>
            <van-icon name="arrow" color="rgb(200, 200, 200)" size="0.4rem" />
          </div>
          <van-divider />
          <div class="cell_item flex-r-sb-c" @click="toJump(4)">
            <div class="msg flex-r-s-c">
              <van-image width="1.07rem" fit="cover" height="1.07rem" style="padding-right:0.21rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale2/my/my_card03.png"
              />
              <div class="flex-c-s-s">
                <div class="name">关于我们</div>
                <div class="contant">企业业务介绍</div>
              </div>
            </div>
            <van-icon name="arrow" color="rgb(200, 200, 200)" size="0.4rem" />
          </div>
          <van-divider />
        </div>
        <!-- <div class="my_cards">
          <van-row>
            <van-col v-for="i in 4" :key="i" span="12">
              <div class="cards_item">
                <van-image width="4.43rem" fit="cover" height="2.4rem"
                           :src="'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my/my_card0'+ i +'.png'"
                           @click="toJump(i)"
                />
              </div>
            </van-col>
          </van-row>
        </div> -->
      </div>
    </div>
    <!-- 退出 -->
    <div class="user_out_login">
      <van-button class="out_login_btn" round color="#0767AB" @click="loginOut">退出登录</van-button>
    </div>
    <!-- Tabber -->
    <Tabber ref="tabber" :index="4" />
    <!-- 客服组件 -->
    <kefuBtn ref="mykefuBtn" />
    <!-- 领取vip -->
    <van-dialog v-model="vipDialog" :show-confirm-button="false" class="my_vip_dialog">
      <div class="vipDialog_box flex-c-c-c">
        <van-image width="5.07rem" height="1.4rem" class="my_vip_dialog_btn"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/vip_my_dialog_btn.png"
                   @click="vipDialog = false"
        />
      </div>
    </van-dialog>
    <!-- vip到期提醒 -->
    <!-- 资质认证弹窗 -->
    <van-dialog v-model="vipDialog2" :show-confirm-button="false">
      <div class="vipDialog_box2 flex-c-c-c">
        <div class="vipDialog_title">Hi，{{ vipDialogInfo.companyName }}</div>
        <div class="vipDialog_msg">您的商城权益还有 <span style="color: #C2460E;">{{ vipDialogInfo.daysRemaining }}</span> 天到期
        </div>
        <div class="vipDialog_time">{{ vipDialogInfo.monthStart }}-{{ vipDialogInfo.monthEnd }}</div>
        <div class="vipDialog_dec">权益等级说明</div>
        <div class="vipDialog_info">权益到期后，将根据您当月在宠商首选商城的消费额或购买严选商品的消费额，重新评定会员等级，次月1号生效，并享受相应权益。</div>
        <div class="vipDialog_btn" @click="vipDialog2 = false">知道了</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import './vip.scss'
import './index.scss'
import { userOrderCardList } from '@/utils/constants'
import Tabber from '@/components/tabber'
import kefuBtn from '@/components/kefu_btn'
import { user_userInfo, logOutMpr, user_coupons } from '@/api/user'
import { mallOrder_buyer_listCount } from '@/api/order'
// import { apiWholesaleVip_member, levelList, apiWholesaleVip_receiveVip } from '@/api/vip'
import { apiWholesaleVip_receiveVip } from '@/api/vip'
export default {
  name: 'My',
  components: { Tabber, kefuBtn },
  data() {
    return {
      info: {
        avatar: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/login/login_logo.png',
        name: '宠商首选用户',
        industryName: '医院-宠医'
      },
      badge: 0,
      fastCellList: [
        // {
        //   iconUrl: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my_cell_01.png',
        //   name: '邀请有礼', tip: '邀多赠多 好礼叠加'
        // },
        {
          iconUrl: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my_cell_02.png',
          name: '联系客服', tip: '专业客服  为您服务'
        },
        {
          iconUrl: 'https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my_cell_03.png',
          name: '关于我们', tip: '企业简介  业务介绍'
        }
      ],
      isVip: false,
      vipInfo: { expirationTime: '', accumulatedSaved: '100' },
      vipIndex: null,
      // vipDialog
      vipDialog: false,
      vipDialogInfo: {},
      vipDialog2: false,
      // order
      userOrderCardList: userOrderCardList,
      userCouponCount: 0
    }
  },
  created() {
    sessionStorage.setItem('order_list_live', 'true')
    this.$utils.cartNum(this.$store)
    this.getInfo()
    this.loadItem()
  },
  methods: {
    getInfo() {
      user_userInfo().then(res => { this.info = res.data })
      // apiWholesaleVip_vipPopUpDowngrading().then(res => { this.vipDialogInfo = res.data; this.vipDialog2 = parseInt(res.data.popUpStatus) === 1 })
      // levelList().then(res => {
      //   apiWholesaleVip_member().then(resx => {
      //     for (var i = 0; i < res.data.list.length; i++) {
      //       if (res.data.list[i].vipLevelId === resx.data.wholesaleVipLevelId) { this.vipIndex = i }
      //     }
      //     this.isVip = resx.data.expirationTime !== null
      //     this.vipInfo = resx.data
      //   })
      // })
      mallOrder_buyer_listCount({ orderStatus: 2 }).then(res => { this.badge = res.data.count })
      user_coupons({ pageNum: 1, pageSize: 999, status: 1 }).then(res => {
        this.userCouponCount = res.data.total
      })
    },
    toJump(index) {
      if (index === 1) { this.$router.push('/order/orderList') }
      if (index === 2) { this.$router.push('/user/addressList') }
      if (index === 3) { this.openKeFu() }
      if (index === 4) { this.$router.push('/user/aboutOus') }
      if (index === 6) { this.$router.push('/agency/myAgency') }
      if (index === 7) { this.$router.push('/user/coupon') }
    },
    fastJump(index) {
      if (index === 1) { this.openKeFu() } else if (index === 2) { this.$router.push('/user/aboutOus') } else { this.$toast({ message: '努力开发中...', duration: 2 * 1000 }) }
    },
    loginOut() {
      logOutMpr().then(res => { this.$utils.localLogout(this) })
    },
    openKeFu() { this.$refs.mykefuBtn.changeShow(true) },
    // vip详情
    toVipDetail() { this.$router.push('/user/vipDetail') },
    getVip() {
      apiWholesaleVip_receiveVip().then(res => {
        this.$toast({ message: '领取成功！', duration: 1 * 1000 })
        this.vipDialog = false; this.$router.push('/user/vipDetail')
      })
    },
    jumpOrder(id) {
      if (parseInt(id) !== 0 && parseInt(id) !== 100) {
        this.$router.push('/order/orderList?status=' + id)
      } else if (parseInt(id) === 100) {
        this.$router.push('/order/orderReturnList?status=' + id)
      } else {
        sessionStorage.setItem('ordeListStatus', id)
        this.$router.push('/order/orderList?status=0')
      }
    }
  }
}
</script>

<style>
</style>
